<dl [class]="'pu-delivery-view pu-delivery-view-' + type()">
  @if (type() === 'admin') {
    <div class="pu-delivery-view__container">
      <dt>{{ 'delivery.fullName' | translate }}</dt>
      <dd>{{ order().firstName + ' ' + order().lastName }}</dd>
    </div>
  }

  <div class="pu-delivery-view__container">
    <dt>{{ 'delivery.deliveryMethod' | translate }}</dt>
    <dd>{{ deliveryMethodName }}</dd>
  </div>

  <div class="pu-delivery-view__container">
    <dt>{{ 'delivery.phoneNumber' | translate }}</dt>
    <dd>{{ order().phone || '-' }}</dd>
  </div>

  @switch (order().deliveryMethod) {
    @case ('pickup') {
      <pu-delivery-view-pickup [delivery]="delivery" />
    }
    @case ('international') {
      <pu-delivery-view-international [delivery]="delivery" />
    }
    @case ('ukrposhta') {
      <pu-delivery-view-ukrposhta [delivery]="delivery" />
    }
    @case ('nova_poshta') {
      <pu-delivery-view-nova-poshta [delivery]="delivery" />
    }
    @case ('fedex') {
      <pu-delivery-view-fedex [delivery]="delivery" />
    }
    @case ('dhl') {
      <pu-delivery-view-dhl [delivery]="delivery" />
    }
    @case ('dpd') {
      <pu-delivery-view-dpd [delivery]="delivery" />
    }
    @case ('inpost') {
      <pu-delivery-view-inpost [delivery]="delivery" />
    }
    @case ('acs') {
      <pu-delivery-view-acs [delivery]="delivery" />
    }
    @case ('gap_akis_express') {
      <pu-delivery-view-gap-akis-express [delivery]="delivery" />
    }
  }

  <div class="pu-delivery-view__container">
    <dt>{{ 'delivery.additionalComment' | translate }}</dt>
    <dd>{{ order().comment || '-' }}</dd>
  </div>
</dl>
